export default __webpack_public_path__ + "static/media/organization.bf6b8ae6.png";